import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { AiFillEye, AiFillGithub } from 'react-icons/ai';
import ProjectImg from '../assets/images/projectImg.png';

const ProjectItemStyles = styled.div`
  .projectItem__img {
    width: 100%;
    height: 400px;
    border-radius: 12px;
    overflow: hidden;
    display: inline-block;
    border: 3px solid var(--gray-2);
    img {
      height: 100%;
    }
  }
  .projectItem__info {
    margin-top: 1rem;
    background-color: var(--deep-dark);
    padding: 1rem;
    border-radius: 12px;
  }
  .projectItem__title {
    font-size: 2.2rem;
  }
  .projectItem__desc {
    font-size: 1.6rem;
    font-family: 'RobotoMono Regular';
    margin-top: 1rem;
  }
  .project-icons {
    display: flex;
    justify-content: center;
    margin-top: 1rem;
    a {
      width: 3rem;
      margin-right: 1rem;
      cursor: pointer;
    }
  }
  @media only screen and (max-width: 768px) {
    .projectItem__img {
      height: 350px;
    }
  }
`;

export default function ProjectItem({
  img = ProjectImg,
  title = 'Project Name',
  desc = 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
  live = '',
  source = '',
  server,
}) {
  return (
    <ProjectItemStyles>
      <Link to="/projects" className="projectItem__img">
        <img src={img} alt="project img" />
      </Link>
      <div className="projectItem__info">
        <Link to="#">
          <h3 className="projectItem__title">{title}</h3>
        </Link>
        <p className="projectItem__desc">{desc}</p>

        <div className="project-icons">
          <a target="_blank" href={live} rel="noreferrer" title="Live Link">
            <AiFillEye />
          </a>
          <a
            target="_blank"
            href={source}
            rel="noreferrer"
            title={server ? 'Client Site Source Code' : 'Source Code'}
          >
            <AiFillGithub />
          </a>
          {server && (
            <a
              target="_blank"
              href={server}
              rel="noreferrer"
              title="Server Site Source Code"
            >
              <AiFillGithub />
            </a>
          )}
        </div>
      </div>
    </ProjectItemStyles>
  );
}
